export enum TasksTypes {
    GET_LIST_TASKS = '@tasks/GET_LIST_TASKS',
    REQUEST_GET_LIST_TASKS = '@tasks/REQUEST_GET_LIST_TASKS',
    SAVE_TASKS = '@tasks/SAVE_TASKS',
    REQUEST_SAVE_TASKS = '@tasks/REQUEST_SAVE_TASKS',
    DELETE_TASK = '@tasks/DELETE_TASK',
    REQUEST_DELETE_TASK = '@tasks/REQUEST_DELETE_TASK',
    DELETE_TASKS = '@tasks/DELETE_TASKS',
    REQUEST_DELETE_TASKS = '@tasks/REQUEST_DELETE_TASKS',
}

export type Task = {
    id: string;
    description?: Record<string, string>;
    image: string | '';
    skills?: Record<string, number>;
    type: string;
    feedback?: Feedback | null;
    options?: Option[];
    languageVideoUrl?: Record<string, string>;
};

export type Option = {
    id: string;
    text?: Record<string, string>;
    imageUrl?: string;
    type: string;
    feedback?: Feedback | null;
    skills?: Record<string, number>;
};

export type Feedback = {
    type: string;
    text: Record<string, string>;
};

export type TasksState = {
    isLoading: boolean;
    tasks: Task[];
};

export type TasksAction<Payload> = {
    type: TasksTypes;
    payload: Payload;
};

export type TaskReducer = (state: TasksState, actions: TasksAction<TasksState>) => TasksState;
